import type { IpFilterDetailsResponse, IpFilterResponse } from '../api-types/ip-filters';
import type { IpFilter, IpFilterDetails } from '../console.types';

export const transformIpFilterResponse = (response: IpFilterResponse): IpFilter => ({
  id: response.id,
  name: response.name,
  organizationId: response.organization_id,
  description: response.description,
  allowList: response.allow_list.map((cidr) => {
    return {
      address: cidr.address,
      prefixLen: cidr.prefix_len,
      description: cidr.description,
    };
  }),
  filteredEntities: {
    organizations: response.filtered_entities.organizations ?? [],
    projects: response.filtered_entities.projects ?? [],
    instances: response.filtered_entities.instances ?? [],
  },
});

export const transformIpFiltersDetailsResponse = (response: IpFilterDetailsResponse): IpFilterDetails => ({
  ...transformIpFilterResponse(response),
  status: response.status,
});
